






















































import { Component, Prop, Vue } from 'vue-property-decorator'
import Frame from '@/data/frame'
@Component({})
export default class FrameTile extends Vue {
  @Prop() private item!: Frame
  private publicPath: string = process.env.BASE_URL
  private imageTimer?: number
  private fadeDuration: number = 60
  private index: number = 0
  private running: boolean = false
  private frameItems: Array<{
    src: string,
    selected: boolean
  }> = []
  private get title (): string {
    return 'look_twice_' + this.item.id
  }

  private mounted () {
    for (let i = 0; i < 36; i++) {
      let n = (i + 1).toString()
      if (i < 9) {
        n = '0' + (i + 1)
      }
      this.frameItems.push({
        src: require('@/assets/images/frames/' + this.item.id.toUpperCase() + '/1_0' + n + '.jpg'),
        selected: false
      })
    }
    this.index = 0
  }

  private toggle360 () {
    if (!this.running) {
      this.running = true
      this.createImageInterval()
    } else {
      clearInterval(this.imageTimer)
      this.running = false
      this.index = 0
    }
  }

  private destroyed () {
    clearInterval(this.imageTimer)
  }

  private createImageInterval () {
    this.imageTimer = setInterval(() => {
      this.index++
      if (this.index >= this.frameItems.length) {
        this.index = 0
      }
    }, this.fadeDuration)
  }
}
